import React, { useEffect, useState } from "react";

// Semicircular SVG gauge — replicates the CSRS/CARS flagship metric widget
const Gauge = ({ value = 74, size = 260 }) => {
  const [animated, setAnimated] = useState(0);

  useEffect(() => {
    const t = setTimeout(() => setAnimated(value), 300);
    return () => clearTimeout(t);
  }, [value]);

  const cx = size / 2;
  const cy = size / 2;
  const r = size / 2 - 22;
  const startAngle = 180;
  const sweep = 180;

  const polar = (angleDeg) => {
    const rad = (angleDeg * Math.PI) / 180;
    return { x: cx + r * Math.cos(rad), y: cy - r * Math.sin(rad) };
  };

  const arcPath = (fromPct, toPct) => {
    const a1 = startAngle - (fromPct / 100) * sweep;
    const a2 = startAngle - (toPct / 100) * sweep;
    const p1 = polar(a1);
    const p2 = polar(a2);
    const large = Math.abs(a1 - a2) > 180 ? 1 : 0;
    return `M ${p1.x} ${p1.y} A ${r} ${r} 0 ${large} 1 ${p2.x} ${p2.y}`;
  };

  const label = value >= 85 ? "Strong" : value >= 65 ? "Adequate" : value >= 45 ? "Developing" : "Exposed";
  const color = value >= 85 ? "#16a34a" : value >= 65 ? "#f59e0b" : value >= 45 ? "#ea7317" : "#dc2626";

  const tickPcts = [0, 25, 50, 75, 100];

  return (
    <div className="relative flex flex-col items-center" data-testid="cars-gauge">
      <svg width={size} height={size / 2 + 40} viewBox={`0 0 ${size} ${size / 2 + 40}`}>
        <path d={arcPath(0.5, 99.5)} fill="none" stroke="#e6e9ef" strokeWidth="13" strokeLinecap="round" />
        <path
          d={arcPath(0.5, Math.max(animated, 1))}
          fill="none"
          stroke={color}
          strokeWidth="13"
          strokeLinecap="round"
          style={{ transition: "d 1.2s cubic-bezier(0.22,1,0.36,1), stroke 0.4s" }}
        />
        {tickPcts.map((p) => {
          const a = startAngle - (p / 100) * sweep;
          const outer = { x: cx + (r + 14) * Math.cos((a * Math.PI) / 180), y: cy - (r + 14) * Math.sin((a * Math.PI) / 180) };
          return (
            <text key={p} x={outer.x} y={outer.y} textAnchor="middle" fontSize="9" fontFamily="JetBrains Mono, monospace" fill="#9aa3b2">{p}</text>
          );
        })}
      </svg>
      <div className="absolute top-[38%] left-0 right-0 flex flex-col items-center">
        <div className="flex items-baseline gap-1">
          <span className="font-heading text-5xl font-bold text-ink">{animated}</span>
          <span className="font-mono text-sm text-neutral-400">/100</span>
        </div>
        <span className="font-heading text-sm font-semibold mt-1" style={{ color }}>{label}</span>
      </div>
    </div>
  );
};

export default Gauge;
